import { createSlice } from "@reduxjs/toolkit";

const LabelSession = createSlice({
  name: "LabelSession",
  initialState: "",
  reducers: {
    saveLabelSession: (state, action) => action.payload,
  },
});

export default LabelSession;
